var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"more-btn",style:('background:' + _vm.bg + ';color:' + _vm.color + ';width:' + _vm.width + 'px;'),attrs:{"to":_vm.url}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }